/* eslint-disable */
/// This file is auto generated - do not edit manually
export const TermsButtonText = 'Website.MyProfile.FrontPage.PersonalOffer.TermsButtonText';
